module.exports = __webpack_public_path__ + "static/media/hall-PH.91c04941.svg";